import type {
  EditorReadyFn,
  FlowEditorSDK,
  GetAppManifestFn,
} from '@wix/yoshi-flow-editor';

import componentJson from './components/MyAccount/.component.json';
import { MANAGE_FIELDS_EV_ID } from './constants';
import {
  getMembersAreaContext,
  globalAppState,
  MembersAreaContext,
  refreshApp,
  registerGfppEventListeners,
} from './editor/services';

const editorReady: EditorReadyFn = async (
  editorSDK,
  _appDefinitionId,
  _,
  flowAPI,
) => {
  globalAppState.setFlowAPI(flowAPI);

  registerGfppEventListeners(editorSDK);
};

const getAppManifest: GetAppManifestFn = async (
  { appManifestBuilder },
  editorSDK,
  _,
  flowAPI,
) => {
  if (!globalAppState.getFlowAPI()) {
    globalAppState.setFlowAPI(flowAPI);
  }

  const membersAreaContext = await getMembersAreaContext(editorSDK);
  const isMembersAreaV2Context = membersAreaContext === MembersAreaContext.V2;
  const isMembersAreaV3Context = membersAreaContext === MembersAreaContext.V3;
  const helpIdV2 = 'f168bedd-2549-4a04-920b-b0b49bb4c7c1';
  const helpIdV3 = 'f168bedd-2549-4a04-920b-b0b49bb4c7c1';

  return appManifestBuilder
    .configureWidget(componentJson.id, (builder) => {
      builder.behavior().set({ removable: false });

      builder.gfpp().set('widgetPlugins', { behavior: 'HIDE' });

      builder.gfpp('desktop').set('mainAction2', {
        actionId: MANAGE_FIELDS_EV_ID,
        label: flowAPI.translations.t('app.settings.main.secondary-cta'),
      });

      if (isMembersAreaV3Context || isMembersAreaV2Context) {
        builder.gfpp('desktop').set('help', {
          id: isMembersAreaV3Context ? helpIdV3 : helpIdV2,
        });
      }
    })
    .build();
};

const _exports = (editorSDK: FlowEditorSDK) => ({
  public: {
    refreshApp: () => refreshApp(editorSDK, 'PUBLIC_API_REFRESH'),
  },
});
export { editorReady, _exports as exports, getAppManifest };
